import React from 'react';
import { FadeInSection } from '../ui/FadeInSection';
export function ObjectionsSection() {
  const objections = [{
    q: '«No tengo tiempo para cocinar diferente»',
    a: 'La belleza de este método es que NO cocinas diferente. Comes exactamente lo mismo que ya preparas, solo cambias el ORDEN en que lo llevas a tu boca.'
  }, {
    q: '«Mi familia come distinto y no puedo cambiar todo»',
    a: "No tienes que cambiar el menú familiar. Si hay pollo, arroz y ensalada, tú simplemente comes tu porción de ensalada primero. Nadie notará que estás 'a dieta'."
  }, {
    q: '«Ya intenté muchas dietas y nada me funciona»',
    a: 'Esto no es una dieta restrictiva. Es un manual de instrucciones para entender cómo funciona tu cuerpo. Por eso funciona cuando las dietas fallan.'
  }, {
    q: '«Mis antojos son demasiado fuertes para controlarlos»',
    a: 'Tus antojos son fuertes porque tus picos de glucosa son altos. Al aplicar la secuencia, cortas el problema de raíz. El antojo simplemente no aparece.'
  }, {
    q: '«Me cuesta mucho ser constante con cualquier plan»',
    a: 'Como no hay alimentos prohibidos ni calorías que contar, el método es tan simple que se vuelve automático en pocos días. No requiere fuerza de voluntad.'
  }, {
    q: '«Trabajo por turnos y mis horarios son muy irregulares»',
    a: 'La Secuencia de Oro funciona sin importar la hora que marque el reloj. Sea de día o de madrugada, la biología de tu digestión es la misma.'
  }];
  return <section className="py-16 md:py-24 bg-[#166534] text-white px-4" data-id="element-317">
      <div className="max-w-4xl mx-auto" data-id="element-318">
        <FadeInSection data-id="element-319">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-amber-50 mb-12" data-id="element-320">
            Sé lo que estás pensando...
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-321">
            {objections.map((obj, index) => <div key={index} className="bg-green-800/40 p-6 rounded-2xl border border-green-700" data-id="element-322">
                <h3 className="text-xl font-bold text-amber-300 mb-3 italic" data-id="element-323">
                  {obj.q}
                </h3>
                <p className="text-green-50 text-lg leading-relaxed" data-id="element-324">{obj.a}</p>
              </div>)}
          </div>
        </FadeInSection>
      </div>
    </section>;
}